import { render, staticRenderFns } from "./ForStudents.vue?vue&type=template&id=2bc2bf9c&lang=pug&"
import script from "./ForStudents.vue?vue&type=script&lang=js&"
export * from "./ForStudents.vue?vue&type=script&lang=js&"
import style0 from "./ForStudents.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports